<template>
  <div>
    <page-title
      title="Your recent projects"
      description="We’d like to hear about 3 of the most recent projects you’ve worked on. This will help to generate your own unique skills graph for job matching that is personalised to you."
    />

    <div class="mt-5">
      <step-item-card
        v-for="(item, i) in details.projects"
        :key="i"
        :title="item.title"
        :description="item.website"
        :details="item.project_details"
        @edit="editItem(i)"
      />
    </div>

    <add-step-item-cta title="project" @click="showProjDialog = true" />

    <AddProject
      :project="project"
      :is-active="showProjDialog"
      :action-type="indexToEdit ? 'update' : 'add'"
      @close="showProjDialog = false"
      @confirm="addProject"
    />
  </div>
</template>

<script setup>
import PageTitle from './PageTitle.vue';
import AddStepItemCta from './AddStepItemCta.vue';
import StepItemCard from './StepItemCard.vue';
import AddProject from './AddProject.vue';
import { ref, onMounted } from 'vue';
import { alert } from '@/utils/helper';

const props = defineProps({
  details: {
    type: Object,
  },
});

const project = ref({
  title: '',
  website: '',
  skills: '',
  project_details: '',
  photo: '',
});
const showProjDialog = ref(false);
const indexToEdit = ref(null);

const editItem = (index) => {
  indexToEdit.value = index;
  project.value = props.details.projects[index];
  showProjDialog.value = true;
};

const addProject = () => {
  const { title, project_details, skills } = project.value;
  if (!title || !project_details || !skills.length) return alert('Please fill all required fields', 'error');

  if (indexToEdit.value == null) {
    props.details.projects.push(project.value);
  } else {
    props.details.projects[indexToEdit.value] = project.value;
    indexToEdit.value = null;
  }

  project.value = {
    title: '',
    website: '',
    skills: '',
    project_details: '',
    photo: '',
  };
  showProjDialog.value = false;
};
</script>
